import React from 'react'
import { sanitizeHtml } from '../../utils/Tools';

const DangerousInnerHtml = (props) => {
  return(
    <div dangerouslySetInnerHTML={{__html: sanitizeHtml(props.customText ?? '')}}>

    </div>
  )
}

export default DangerousInnerHtml